import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ModalModule } from '../../../../core/modal/modal.module';
import { FormModule } from '../../../../shared/components/form-controls/form.module';
import { SharedModule } from '../../../../shared/shared.module';
import { ModalService } from '../../../../core/modal/modal.service';
import { AddressFormModel, RetailPlaceRegexp } from '../new-retail-place.model';

@Component({
  selector: 'tax-manual-input-address',
  templateUrl: './manual-input-address.component.html',
  styleUrls: ['./manual-input-address.component.sass'],
  standalone: true,
  imports: [
    ModalModule,
    TranslateModule,
    FormModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
  ],
})

export class ManualInputAddressComponent {
  @Input() regExp?: RetailPlaceRegexp;
  @Input() set inputStreet(value: string) {
    this.street = value;
    this.streetDisabled = !!value;
  }

  street = '';
  house = '';
  apartment = '';
  streetDisabled = false;
  readonly alertMessage = 'select.manual.input.modal.content';

  constructor(private modalService: ModalService) {}

  confirmChanges(street: string, house: string, apartment: string): void {
    this.modalService.close<AddressFormModel>({
      street, house, apartment,
    });
  }

  formValidation(): boolean {
    const isStreetValid = this.street
      ? new RegExp(`^${this.regExp?.street ?? ''}$`).test(this.street)
      : false;
    const isHouseValid = this.house
      ? new RegExp(`^${this.regExp?.house ?? ''}$`).test(this.house)
      : false;
    const isApartmentValid = this.apartment
      ? new RegExp(`^${this.regExp?.apartment ?? ''}$`).test(this.apartment)
      : true;
    return (
      Boolean(this.street && this.house)
      && isStreetValid
      && isHouseValid
      && isApartmentValid
    );
  }
}
